import React, { useState, useEffect } from "react";
import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { GoBriefcase } from "react-icons/go";
import { TfiLocationPin } from "react-icons/tfi";
import { CiSearch } from "react-icons/ci";
import MultiRangeSlider from "multi-range-slider-react";
import JobsList from "../component/jobs-list";
import { useLocation } from "react-router-dom";
import { jobCategoryApi, jobSalaryRangeApi, jobTypeApi } from "../service/apis/employer.api";

const JoblistingScreen = () => {
  const [jobCategory, setJobCategory] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [salaryRange, setSalaryRange] = useState<any>({ minSalary: 0, maxSalary: 0 });

  const locationn = useLocation();

  /*const [minValue, setMinValue] = useState(1);
    const [maxValue, setMaxValue] = useState(1000);*/

  const [categories, setCategories] = useState<string[]>([]);
  const [jobTypes, setJobTypes] = useState<string[]>([]);

  const [salaryMin, setSalaryMin] = useState<number | null>(null);
  const [salaryMax, setSalaryMax] = useState<number | null>(null);

  /*const [industry, setIndustry] = useState("");
    const [location, setLocation] = useState("");*/

  const [formValues, setFormValues] = useState({
    industry: "",
    location: "",
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);
    const industry = formData.get("industry") as string;
    const location = formData.get("location") as string;

    /*if (!industry && !location) {
      setError("Both fields are required."); 
      return; 
    }
	
    setError("");*/

    //setFormValues(formValues);
    setFormValues({ industry, location });
  };

  const handleCheckboxChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { minValue: number; maxValue: number },
    type: "category" | "jobType" | "salary"
  ) => {
    if (type === "category" || type === "jobType") {
      const value = (e as React.ChangeEvent<HTMLInputElement>).target.value;
      const isChecked = (e as React.ChangeEvent<HTMLInputElement>).target
        .checked;
      if (type === "category") {
        setCategories((prev) =>
          isChecked ? [...prev, value] : prev.filter((item) => item !== value)
        );
      } else if (type === "jobType") {
        setJobTypes((prev) =>
          isChecked ? [...prev, value] : prev.filter((item) => item !== value)
        );
      }
    } else if (type === "salary") {
      const { minValue, maxValue } = e as {
        minValue: number;
        maxValue: number;
      };
      setSalaryMin(minValue);
      setSalaryMax(maxValue);
    }
  };

  useEffect(() => {
    //console.log(locationn.state);
    if (locationn.state) {
      const { industry, location: formLocation, categoryId } = locationn.state;
      setFormValues({
        industry: industry || "",
        location: formLocation || "",
      });
      //console.log(categoryId);
      //navigate(locationn.pathname, { replace: true });
      if (categoryId) {
        setCategories(prevCategories => [...prevCategories, categoryId]);
      }
    }
  }, [locationn.state]);
  //}, [locationn, navigate]);

  const jobCategoryLists = async () => {
    //setIsLoading(true);
    try {
      const response = await jobCategoryApi();
      setJobCategory(response.categories);
    } catch (error) {
      console.error("Catch Error: ", error);
    } finally {
      //setIsLoading(false);
    }
  };

  const jobTypeLists = async () => {
    //setIsLoading(true);
    try {
      const response = await jobTypeApi();
      setJobType(response.types);
    } catch (error) {
      console.error("Catch Error: ", error);
    } finally {
      //setIsLoading(false);
    }
  };

  const jobSalaryRange = async () => {
    try {
      const response = await jobSalaryRangeApi();
      // console.log(response.salary[0].minSalary,response.salary[0].maxSalary,6666);
      
     if (response?.salary?.[0]) {
        const minSalary=response.salary[0].minSalary;
        const maxSalary=response.salary[0].maxSalary;
        setSalaryMin(minSalary);
        setSalaryMax(maxSalary);
        setSalaryRange({
            minSalary: minSalary,
            maxSalary: maxSalary,
        });
    }
    else
    {
      console.log("issues");
      
    }
    } catch (error) {
      console.error("Catch Error: ", error);
    }
  };


  useEffect(() => {
    jobCategoryLists();
    jobTypeLists();
    jobSalaryRange();
  }, []);

  //console.log("Catt",categories);

  return (
    <>
      {/* <HeaderScreen /> */}
      <div className="front-pages">
        <section className="home-banner innerBanner position-relative common-padd-xl">
          <div className="homeLine">
            <img src={Innerbannerlines} alt="line icon" />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="innerBanner-info text-center">
                  <h1>Jobs</h1>
                  <div className="breadcrumb-holder text-center">
                    <Breadcrumb>
                      <Breadcrumb.Item href="#">
                        <img src={Logoicon} alt="logo icon" /> Home
                      </Breadcrumb.Item>
                      <Breadcrumb.Item active>Jobs</Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="joblist-holder position-relative common-padd-xl pt-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                {/* <Form onSubmit={handleSearch}> */}
                <Form onSubmit={handleSubmit}>
                  <h3>Find A Job</h3>
                  <div className="jobsearchbar comnbrdrGap mb-3">
                    <div className="jobsearch">
                      <Form.Group className="iconinside mb-3">
                        <div className="icon">
                          <GoBriefcase />
                        </div>
                        <Form.Control
                          type="text"
                          placeholder="Keyword or Job title"
                          name="industry"
                          defaultValue={formValues.industry}
                        //value={industry}
                        //onChange={(e) => setIndustry(e.target.value)}
                        />
                      </Form.Group>
                      <Form.Group className=" iconinside mb-3">
                        <div className="icon">
                          <TfiLocationPin />
                        </div>
                        <Form.Control
                          type="text"
                          placeholder="Location"
                          name="location"
                          defaultValue={formValues.location}
                        //value={location}
                        //onChange={(e) => setLocation(e.target.value)}
                        />
                      </Form.Group>
                      <Button className="btn btn-black w-100" type="submit">
                        {" "}
                        <CiSearch />
                        Search
                      </Button>
                    </div>
                  </div>
                </Form>

                <Form>
                  <h3>Category</h3>
                  <div className="checkcategories comnbrdrGap mb-3">
                    <div className="scrollHolder">
                      {jobCategory &&
                        jobCategory.map((category: any, index: any) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            label={`${category?.categoryName} (${category?.jobCount})`}
                            value={category?.id}
                            checked={categories.includes(category?.id)}
                            onChange={(e) =>
                              handleCheckboxChange(e, "category")
                            }
                          />
                        ))}
                      {/*<Form.Check
                                                type="checkbox"
                                                label="Digital & Creative (5)" />
                                            <Form.Check
                                                type="checkbox"
                                                label="Sales & Marketing (6)" />*/}
                    </div>
                  </div>
                  <h3>Job Type</h3>
                  <div className="checkcategories comnbrdrGap mb-3">
                    <div className="scrollHolder">
                      {
                        /*["Temporary", "Remote", "Part Time", "Internship", "Full Time", "Freelancer"].map(*/
                        jobType &&
                        jobType.map((jobTypee: any, index: any) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            label={`${jobTypee?.typeName} (${jobTypee?.jobCount})`}
                            value={jobTypee?.id}
                            onChange={(e) =>
                              handleCheckboxChange(e, "jobType")
                            }
                          />
                        ))
                      }
                      {/*<Form.Check
                                                type="checkbox"
                                                label="All (50)" />
                                            <Form.Check
                                                type="checkbox"
                                                label="Temporary (2)" />*/}
                    </div>
                  </div>
                  <h3>Salary</h3>
                  <div className="checkcategories comnbrdrGap">
                    <div className="App">
                      <div className="multi-range-slider-container">
                        <h6>Range</h6>
                        {salaryRange.minSalary > 0 && salaryRange.maxSalary > 0 && (
                        <MultiRangeSlider
                          min={salaryRange.minSalary}
                          max={salaryRange.maxSalary}
                          step={Math.ceil((salaryRange.maxSalary - salaryRange.minSalary) / 100)}                          
                          minValue={salaryMin ?? salaryRange.minSalary}
                          maxValue={salaryMax ?? salaryRange.maxSalary}
                          onInput={(e) =>
                            handleCheckboxChange(
                              { minValue: e.minValue, maxValue: e.maxValue },
                              "salary"
                            )
                          }
                        />
                      )}

                        <div className="slidervaluesHolder">
                          <div style={{ margin: "1px" }}>
                            {salaryMin ?? salaryRange.minSalary}
                          </div>
                          <div style={{ margin: "1px" }}>
                            {salaryMax ?? salaryRange.maxSalary}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
              <div className="col-lg-9">
                <JobsList
                  categories={categories}
                  jobTypes={jobTypes}
                  salaryMin={salaryMin}
                  salaryMax={salaryMax}
                  industry={formValues.industry}
                  location={formValues.location}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* <FooterScreen /> */}
    </>
  );
};
export default JoblistingScreen;
